/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TabBarQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly hasNewNotifications: boolean | null;
    readonly " $refType": "TabBarQueryLocal";
};
export type TabBarQueryLocal$data = TabBarQueryLocal;
export type TabBarQueryLocal$key = {
    readonly " $data"?: TabBarQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"TabBarQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TabBarQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNewNotifications",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '1b1cdb94eaae7ac18a611c702675801d';
export default node;
